import React, { useEffect, useState } from "react";
import CgFormCreator from "../../common/CgFormCreator";
import "./resetPassword.scss";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchUserByToken,
  fetchChangePassword,
} from "../../store/Login/LoginActions";

const ResetPassword = () => {
  const passwordRegex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  // const [passwordsNotMatch, setPasswordsNotMatch] = useState(false);
  const [popupValue, setpopupValue] = useState(false);
  const [resetFormSubmit] = useState(false);
  // const [errors, setErrors] = useState(true);
  const [isPasswordValid, setIsPasswordValid] = useState(false);
  const [showError, setShowError] = useState(false);
  // const [userData, setUserData] = useState(null);

  const windowLocation = useLocation();
  const dispatch = useDispatch();
  const navigateTo = useNavigate();

  const { userByTokenError, userByTokenData, changePasswordData } = useSelector(
    (state) => state.loginUserDetails
  );

  // const { changePasswordData } = useSelector((state) => state.resetPassword);

  const handleNewPasswordChange = (value) => {
    setNewPassword(value);
    const isValid = passwordRegex.test(value);
    setpopupValue(!isValid);
    setIsPasswordValid(isValid);
  };

  const handleConfirmPasswordChange = (value) => {
    setConfirmNewPassword(value);
  };

  // useEffect(() => {
  //   setPasswordsNotMatch(newPassword !== confirmNewPassword);
  // }, [newPassword, confirmNewPassword]);

  const getUserByToken = () => {
    const hashParams = new URLSearchParams(window.location.hash.split("?")[1]);
    return hashParams.get("token");
  };

  console.log({ userByTokenError });

  const userToken = getUserByToken();

  useEffect(() => {
    if (userToken) {
      dispatch(fetchUserByToken(userToken));
      // .then((res) => {
      //   if (res?.payload?.data) {
      //     const response = response.payload.data;
      //     // console.log({ response, userDetailsByTokenData });
      //     setUserData(response.payload.data);
      //   }
      // });
    }
  }, [userToken]);

  // useEffect(() => {
  //   const isValid =
  //     newPassword &&
  //     confirmNewPassword &&
  //     passwordRegex.test(newPassword) &&
  //     !popupValue &&
  //     !passwordsNotMatch;
  //   setErrors(!isValid);
  // }, [newPassword, confirmNewPassword, passwordsNotMatch]);

  const ResetPasswordSchema = [
    {
      component: "input",
      label: "Enter New Password*",
      type: "password",
      name: "newpassword",
      required: true,
      placeholder: "",
      onKeyChangeCallback: (name, value) => handleNewPasswordChange(value),
      valueChangeCallback: () => {},
      popupErrorMsg: popupValue,
      tooltipMsg:
        "Password length must be at least eight(8) characters and must contain three of the four character types – upper case, lower case, numeric and/or special character",
      formClassName: isPasswordValid ? "inputValid" : "input-invalid",
    },
    {
      component: "input",
      label: "Confirm New Password*",
      type: "password",
      name: "confirmnewpassword",
      required: true,
      placeholder: "",
      onKeyChangeCallback: (name, value) => handleConfirmPasswordChange(value),
      valueChangeCallback: () => {},
    },
  ];

  useEffect(() => {
    if (resetFormSubmit) {
      setNewPassword("");
      setConfirmNewPassword("");
    }
  }, [resetFormSubmit]);

  const handleSubmitResetPassword = () => {
    if (newPassword !== confirmNewPassword) {
      setShowError(true);
      return;
    }
    setShowError(false);

    const payload = {
      token: userToken,
      // userName: "udayraj.n@evernorth.com",
      userName: userByTokenData?.username,
      password: newPassword,
    };

    dispatch(fetchChangePassword(payload)).then((response) => {
      console.log("Password changed successfully", response);
    });
  };

  const RenderResetPasswordFormCreator = () => {
    if (userByTokenData?.status === 404) return null;
    return (
      <div className="resetForm">
        <h3 className="resetHeader">Please Create a new password</h3>
        {showError && (
          <p style={{ color: "black", marginBottom: "10px" }}>
            {`Passwords didn't match`}
          </p>
        )}
        <CgFormCreator
          key={resetFormSubmit}
          schema={ResetPasswordSchema}
          primaryButton={
            <span>
              UPDATE <i className="bi bi-chevron-right" />
            </span>
          }
          noCancel
          onSubmitCallback={(res) => {
            handleSubmitResetPassword(res);
          }}
          resetValuesOnSubmit={resetFormSubmit}
          enablePrimaryBtn={true}
        />
      </div>
    );
  };

  const RenderPasswordUpdateStatus = () => {
    if (userByTokenData?.status === 404) return null;
    return (
      <div className="resetForm">
        <div className="resetHeader">Your password has been updated.</div>
        <div
          className="loginBack"
          onClick={() => {
            navigateTo("/login");
          }}
        >
          <span>
            Login <i className="bi bi-chevron-right" />
          </span>
        </div>
      </div>
    );
  };

  const RenderPasswordLinkExpired = () => {
    if (userByTokenData?.status !== 404) return null;
    return (
      <div className="resetForm">
        <div className="resetHeader">Password Token Expired</div>
        <p>
          This password reset token has expired.
          <span
            style={{
              margin: "8px",
              cursor: "pointer",
              color: "#0077b7",
            }}
            onClick={() => {
              navigateTo("/forgotPassword");
            }}
          >
            Click here
          </span>
          if you would like to reset your password.
        </p>
      </div>
    );
  };

  if (!userByTokenData) return <div> Loading ... </div>;
  return (
    <div>
      {!changePasswordData
        ? RenderResetPasswordFormCreator()
        : RenderPasswordUpdateStatus()}
      {/* {RenderPasswordLinkExpired()} */}
      {RenderPasswordLinkExpired()}
    </div>
  );
};

export default ResetPassword;
